export const ADD_FEED_POST                  = 'ADD_FEED_POST';
export const HYDRATE_FEED_POST              = 'HYDRATE_FEED_POST';
export const ADD_FEED_POSTS                 = 'ADD_FEED_POSTS';
export const SET_SINGLE_POST_MODAL_VISIBLE  = 'SET_SINGLE_POST_MODAL_VISIBLE';



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/activity-feed/constants.es6